﻿import config from "../config"
const baseUrl = config.base_url + "container/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    remove: {
        url:  baseUrl + "delete",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    copy: {
        url:  baseUrl + "copy",
        type: "get",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    zoneList: {
        url: baseUrl + "zoneList",
        type: "get",
    },
    specieList: {
        url: baseUrl + "specieList",
        type: "get",
    },
    containerListBySpeciesId: {
        url: baseUrl + "containerListBySpeciesId",
        type: "get",
    },
} 
